import {css} from '@yandex-delivery/blocks/theme/css'

/**
 * Доп. CSS-переменные до гидрации и для timeline (--ui-colors-*).
 * --colorScheme-* на :root выставляет RouteThemeProvider (GWC) по mode light/dark.
 */
export default css`
  :global() {
    :root {
      --ui-colors-background: white;
      --ui-colors-background-minor: #EFEFEE;
      --ui-colors-text: #21201F;
      --ui-colors-text-minor: rgba(33, 32, 31, 0.5);
      --ui-colors-control-main: #FCE000;
      --colorScheme-background-rgb: 255, 255, 255;
    }

    html[data-theme="dark"] {
      --ui-colors-background: #191918;
      --ui-colors-background-minor: #302F2D;
      --ui-colors-text: #E0DEDA;
      --ui-colors-text-minor: rgba(224, 222, 218, 0.5);
      --ui-colors-control-main: #FCE000;
      --colorScheme-background-rgb: 25, 25, 24;
    }
  }
`
